// extracted by mini-css-extract-plugin
export var deleteIcon = "_p1-5";
export var deleteOption = "_p1-3";
export var divider = "_p1-2";
export var downloadIcon = "_p1-4";
export var drawer = "_p1-0";
export var drawerFooter = "_p1-6";
export var drawerOpen = "_p1-1";
export var highlighted = "_p1-7";
export var lighterHighlight = "_p1-8";